import type { RegionNode } from '../api/regions';

export interface RegionOption {
  id: string;
  name: string;
  code: string;
  /** Names of the subregions this region covers, for display only. Access to a
   *  top-level region already covers everything inside it, so operators need to
   *  see what they are granting without being able to pick the parts. */
  covers: string[];
  directorUserId: string | null;
}

/**
 * Top-level regions only — the whole set a person can be attached to.
 *
 * People attach top-level and inherit the subtree (BON-449), which the backend
 * now enforces. Offering subregions here produced pickable options that could
 * only ever come back as a 400.
 */
export function topLevelRegionOptions(tree: RegionNode[]): RegionOption[] {
  return tree.map((n) => ({
    id: n.id,
    name: n.name,
    code: n.code,
    covers: (n.children ?? []).map((c) => c.name),
    directorUserId: n.directorUserId ?? null,
  }));
}

/**
 * The regions a Regional Director can be given: those with no director, or
 * the one this person already directs.
 */
export function regionsOpenToDirector(
  options: RegionOption[],
  userId: string | null,
): RegionOption[] {
  return options.filter((o) => o.directorUserId === null || o.directorUserId === userId);
}
